import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter as Router } from 'react-router';

import ErrorFallback from './pages/ErrorFallback/ErrorFallback';
import AppRoutes from './routes/AppRoutes';
import AuthContextProvider from './shared/context/auth/AuthContext';
import BrokerProvider from './shared/context/broker/BrokerContext';
import IntercomProvider from './shared/context/intercom/IntercomProvider';
import ProspectsProvider from './shared/context/prospect/ProspectContext';
import StatsigCustomProvider from './shared/context/statsig/statsigContext';
import UserContextProvider from './shared/context/user/UserContext';

function App() {
  return (
    <Router>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <AuthContextProvider>
          <UserContextProvider>
            <IntercomProvider>
              <StatsigCustomProvider>
                <BrokerProvider>
                  <ProspectsProvider>
                    <AppRoutes />
                  </ProspectsProvider>
                </BrokerProvider>
              </StatsigCustomProvider>
            </IntercomProvider>
          </UserContextProvider>
        </AuthContextProvider>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
